import _slicedToArray from "/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
export function clamp(t, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      a = _ref2[0],
      n = _ref2[1];

  return Math.min(n, Math.max(a, t));
}